import { DepositType, DepositTypeObjects, VoucherProviders, RewardTypes } from './types';

export const DEPOSIT_TYPES: DepositTypeObjects = [
  {
    key: 'Percentage',
    value: DepositType.Percentage,
  },
  {
    key: 'First Instalment',
    value: DepositType.Instalment,
  },
  {
    key: 'Flat',
    value: DepositType.Flat,
  },
];

export const TIME_UNITS = [
  {
    key: 'Minutes',
    value: 'MINUTES',
  },
  {
    key: 'Hours',
    value: 'HOURS',
  },
  {
    key: 'Days',
    value: 'DAYS',
  },
];

export const VOUCHER_PROVIDERS = [
  {
    key: 'SHOPIFY',
    value: VoucherProviders.SHOPIFY,
  },
];

export const ORDER_TYPES = [
  {
    key: 'Payment Plan',
    value: 'PAYMENT_PLAN',
  },
  {
    key: 'Voucher Savings Plan',
    value: 'BOOST_PLAN',
  },
];

export const REWARD_TYPES = [
  {
    key: 'Percentage',
    value: RewardTypes.Percentage,
  },
  {
    key: 'Flat',
    value: RewardTypes.Flat,
  },
];
